import { Injectable } from '@angular/core';
import { FilterOptions } from '../shared/model/filter.model';
import { CompletenessLevel } from '../shared/model/profile-completeness';
import { CompanyFilter } from '../shared/model/company.model';
import type { SearchScope } from '../entities/userlist/search-scope';

@Injectable({ providedIn: 'root' })
export class UserFilterStateService {
  filter: FilterOptions = null;
  sortColumn: string | null = null;
  // Search + toggles are mirrored here (like filter/sortColumn) so they survive any
  // in-app navigation — incl. breadcrumb-back, which drops the URL query string (NP20-829).
  search = '';
  // Der Bereich der Suche wird wie der Suchbegriff daneben gemerkt. Der Standard steht
  // als Literal: ein Feld-Initialisierer liest die geteilte Konstante im gebuendelten
  // Testlauf noch als undefined.
  searchScope: SearchScope = 'name';
  applicantOnly = false;
  freelancerOnly = false;
  company: CompanyFilter = 'ALL';
  // Ampel-Auswahl der Profilvervollstaendigung (NP20-1192) — wie die uebrigen Filter
  // nur fuer die Dauer der Sitzung, damit sie den Weg ins Profil und zurueck uebersteht.
  completenessLevels: CompletenessLevel[] = [];
}
